// Folio EFECTIVO de una fila de Facturación > Ventas (`_displayFolio`): el que usan el filtro por
// Nº de factura, su lista de folios y el orden de la tabla.
//
// La vinculación SII por ID (el puente, `siiMap._byRef[refKeyDeOportunidad(op)]`) es la fuente
// primaria; el texto `facturanumero` queda como fallback para las ventas sin vinculación (históricas).
//
// P2.100: función ÚNICA, usada por la carga inicial (`injectSIIDates`) y por `recargarSiiMap`
// (useVFDataLoading). Antes se calculaba solo al cargar la página, así que tras vincular/desvincular
// el folio quedaba viejo hasta recargar.
import { refKeyDeOportunidad } from "./lineasFacturacion/refKey";

export const derivarDisplayFolio = (oportunidad, siiMap) => {
  const refKey = refKeyDeOportunidad(oportunidad);
  const byRef = refKey ? siiMap?._byRef?.[refKey] : null;
  return byRef ? String(byRef.folio) : oportunidad?.facturanumero || null;
};
